export default __webpack_public_path__ + "static/media/toyota_logo.0fe412b2.svg";